import React from 'react';
import Helmet from 'react-helmet';
import { Grid, Button, LinearProgress } from '@material-ui/core';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { CSSProperties } from 'styled-components';

import BetaIcon from 'assets/icons/beta.svg';
import { selectUser } from 'entities/user/selectors';
import Box from 'retired/Box';
import Img from 'retired/Img';
import { Features } from 'utils/features';
import { Privileges } from 'utils/privileges';
import { PageBannerContainer } from 'components/PageBannerContainer/PageBannerContainer';
import ReportsPageBanner from 'assets/pageBanners/reports.avif';

import { DashboardDefinition } from './dashboardDefinitions';
import { useAvailableDashboardDefinitions } from './hooks';

const betaIconStyle: CSSProperties = {
  position: 'absolute',
  top: -9,
  left: -9,
};

const DashboardsListPage: React.FC = () => {
  const user = useSelector(selectUser);
  const history = useHistory();
  const { dashboardDefinitions, loading } = useAvailableDashboardDefinitions();

  if (
    user &&
    (!user.hasFeature(Features.ADVANCED_DASHBOARDS) ||
      !user.hasPrivilege(Privileges.ADVANCED_DASHBOARD_VIEW))
  ) {
    history.replace('/');
  }

  return (
    <>
      <Helmet title="Dashboards" />
      <PageBannerContainer color="#FFE5B4" backgroundImage={ReportsPageBanner}>
        <div style={{ display: 'flex', width: 'fit-content' }}>
          <h1>Dashboards</h1>
        </div>
      </PageBannerContainer>

      {loading ? (
        <LinearProgress />
      ) : (
        <Grid container>
          {dashboardDefinitions.map((item: DashboardDefinition) => (
            <Grid item lg={4} md={6} sm={12} key={item.type} style={{ padding: 10 }}>
              <Box style={{ height: 260 }}>
                <div style={{ position: 'relative' }}>
                  <Img src={item.icon} alt={item.title || ''} />
                  {item.beta ? <Img src={BetaIcon} style={betaIconStyle} alt="Beta icon" /> : null}
                </div>

                <h4>{item.title}</h4>
                <p style={{ fontSize: 14, letterSpacing: -0.3 }}>{item.text}</p>
                <Link to={`/dashboards/${item.type}`}>
                  <Button
                    color="primary"
                    type="button"
                    endIcon={<ArrowForwardIcon style={{ fontSize: 16 }} />}
                  >
                    View
                  </Button>
                </Link>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </>
  );
};

export default DashboardsListPage;
